import STORAGE_TYPES from './storageTypes';
import StorageUtil from './storageUtil';

let localStorageReference;
let sessionStorageReference;
const stores = [];

const storageManager = {
  init() {
    const webStorageAvailability = StorageUtil.checkWebStorage();

    if (webStorageAvailability.session) {
      sessionStorageReference = StorageUtil.createWebStorage(window.sessionStorage, STORAGE_TYPES.SESSION);

      if (webStorageAvailability.local) {
        localStorageReference = StorageUtil.createWebStorage(window.localStorage, STORAGE_TYPES.LOCAL);
      } else {
        localStorageReference = StorageUtil.createWebStorage(window.sessionStorage, STORAGE_TYPES.SESSION);
      }
    } else {
      localStorageReference = StorageUtil.createWebStorageStub(STORAGE_TYPES.SESSION);
      sessionStorageReference = StorageUtil.createWebStorageStub(STORAGE_TYPES.LOCAL);
    }
  },

  getLocalStorage() {
    return localStorageReference;
  },

  getSessionStorage() {
    return sessionStorageReference;
  },

  registerStore(store) {
    stores.push(store);
  },

  clearAllStores() {
    stores.forEach((store) => {
      store.clear();
    });
  },
};

storageManager.init();

export default storageManager;
